import {useContext} from "react";
import {UpdatedObjectCountContext} from "../providers/UpdatedObjectCountProvider";

export const useShiftUpdateCount = () => {
    const {updatedShiftCount, resetDataUpdateCount, fetchDataUpdates, keystore} = useContext(UpdatedObjectCountContext);
    return {updatedShiftCount, resetDataUpdateCount, fetchDataUpdates, keystore};
}
